var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tab-menu"},[_c('div',{staticClass:"progress"},[_c('nav',{staticClass:"row"},_vm._l((_vm.tabs),function(tab,index){return _c('button',{key:index,class:[
          'tab-item',
          { 'active': _vm.activeTabIndex === index }
        ],on:{"click":function($event){return _vm.handleTabClick(index)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0),_c('div',{staticClass:"progress-bar"},_vm._l((_vm.tabs),function(_,index){return _c('div',{key:'circle-' + index,staticClass:"progress-item"},[_c('div',{class:[
            'circle',
            { 'completed': index === _vm.activeTabIndex }
          ],on:{"click":function($event){return _vm.handleTabClick(index)}}}),(index < _vm.tabs.length - 1)?_c('div',{class:[
            'connector',
            { 'completed': index < _vm.activeTabIndex }
          ]}):_vm._e()])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }